import { render, staticRenderFns } from "./CustomCardTab.vue?vue&type=template&id=71456914&scoped=true"
import script from "./CustomCardTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCardTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomCardTab.vue?vue&type=style&index=0&id=71456914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71456914",
  null
  
)

export default component.exports